import React from "react";
import { FaLaptop, FaMicrochip, FaMemory, FaDesktop, FaCheckCircle, FaTimesCircle } from "react-icons/fa";

function LaptopDetails({ product }) {
    if (!product) return <p className="productspec-error">Məhsul detalları yüklənmir...</p>;

    const getStatus = (val, yes = "Bəli", no = "Xeyr") =>
        val === true ? yes : val === false ? no : "Bilinmir";

    const specs = [
        { label: "Ad", value: product.name, icon: <FaLaptop /> },
        { label: "Şəhər", value: product.city },
        { label: "Kateqoriya", value: product.categoryName },
        { label: "Sub-kateqoriya", value: product.subCategoryName },
        { label: "Marka", value: product.brandName },
        { label: "Model", value: product.modelName },
        { label: "Yaddaş", value: product.storage ? `${product.storage} GB` : null, icon: <FaMemory /> },
        { label: "Yaddaş Növü", value: product.storageType },
        { label: "RAM", value: product.ram ? `${product.ram} GB` : null, icon: <FaMicrochip /> },
        { label: "Əməliyyat sistemi", value: product.operatingSystem },
        { label: "Ekran ölçüsü", value: product.screenSize ? `${product.screenSize} inch` : null, icon: <FaDesktop /> },
        { label: "Çözünürlük", value: product.resolution },
        { label: "Yenilənmə tezliyi", value: product.refreshRate ? `${product.refreshRate} Hz` : null },
        { label: "Prosessor", value: product.processor },
        { label: "Video kart (GPU)", value: product.gpu },
        { label: "Sensor ekran", value: getStatus(product.hasTouchScreen), status: product.hasTouchScreen },
        { label: "İşıqlı klaviatura", value: getStatus(product.hasBacklitKeyboard), status: product.hasBacklitKeyboard },
        { label: "Barmaq izi oxuyucu", value: getStatus(product.hasFingerprintReader), status: product.hasFingerprintReader },
        { label: "Web kamera", value: getStatus(product.hasWebcam), status: product.hasWebcam },
        { label: "Rəng", value: product.color },
        { label: "Çəki", value: product.weight ? `${product.weight} kg` : null },
        { label: "Zəmanət", value: getStatus(product.hasWarranty), status: product.hasWarranty },
        { label: "Vəziyyəti", value: product.condition }
    ];

    return (
        <div className="productspec-container productspec-container--electronics">
            <div className="productspec-header">
                <FaLaptop className="productspec-header__icon" />
                <h3 className="productspec-header__title">Laptop Məlumatları</h3>
            </div>

            <div className="productspec-grid">
                {specs.map((spec, index) => {
                    if (!spec.value || spec.value === "Bilinmir") return null;
                    
                    return (
                        <div key={index} className="productspec-item">
                            {spec.icon && <span className="productspec-item__icon">{spec.icon}</span>}
                            <div className="productspec-item__content">
                                <span className="productspec-item__label">{spec.label}</span>
                                <span className={`productspec-item__value ${spec.status !== undefined ? (spec.status ? 'productspec-item__value--success' : 'productspec-item__value--neutral') : ''}`}>
                                    {spec.status !== undefined && (
                                        spec.status ? <FaCheckCircle className="productspec-status-icon productspec-status-icon--success" /> : <FaTimesCircle className="productspec-status-icon productspec-status-icon--neutral" />
                                    )}
                                    {spec.value}
                                </span>
                            </div>
                        </div>
                    );
                })}
            </div>

            {product.description && (
                <div className="productspec-description">
                    <h4 className="productspec-description__title">Əlavə Təsvir</h4>
                    <p className="productspec-description__text">{product.description}</p>
                </div>
            )}
        </div>
    );
}

export default LaptopDetails;